/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteAttachmentModal_attachment$ref: FragmentReference;
declare export opaque type DeleteAttachmentModal_attachment$fragmentType: DeleteAttachmentModal_attachment$ref;
export type DeleteAttachmentModal_attachment = {|
  +id: string,
  +name: string,
  +$refType: DeleteAttachmentModal_attachment$ref,
|};
export type DeleteAttachmentModal_attachment$data = DeleteAttachmentModal_attachment;
export type DeleteAttachmentModal_attachment$key = {
  +$data?: DeleteAttachmentModal_attachment$data,
  +$fragmentRefs: DeleteAttachmentModal_attachment$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DeleteAttachmentModal_attachment",
  "type": "Attachment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '3bf51b8db737223cf8324dec212893ff';
module.exports = node;
